"use strict";

/* eslint-disable no-cond-assign */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
const userProfileData = window.getProfileData();
const headers = window.baseHeadersJsonApi;
const commentCharactersCount = 1500;
const siteWrap = document.querySelector('.site_wrap');
const threadCountElement = document.querySelector('.js_threadCount');
const commentTextarea = document.querySelector('.js_postTextarea');
const mentionContainer = document.getElementById('mentionContainer');
const sendButton = document.querySelector('.js_sendButton');
const commentsWrap = document.querySelector('.list_comments');
const avatarElement = document.querySelector('.js_avatarElement');
const commentSelector = '.js_threadComment';
let unprocessedComments = [];
const reportSelector = '.js_commentReport';
const mentionListSelector = '.mention-list';
const noMatchSelector = 'ul.no-match';
let threadCount = threadCountElement ? Number(threadCountElement.innerText) : 0;
let globalCursorPosition = -1;
function shouldToggleButtonVisibility(element, position = 'top', offset = 0) {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  const viewHeight = window.innerHeight || document.documentElement.clientHeight;
  if (position === 'top') {
    return rect.top >= 0 && rect.top <= viewHeight + offset;
  }
  if (position === 'bottom') {
    return rect.bottom >= 0 && rect.bottom <= viewHeight + offset;
  }
  return false;
}
function checkAndSetTruncatedClass() {
  const userVerifiedElements = document.querySelectorAll('.js_verifiedUser');
  if (!userVerifiedElements.length) return;
  userVerifiedElements.forEach(userVerifiedElement => {
    userVerifiedElement.classList.toggle('has-truncated-username', userVerifiedElement.scrollWidth > userVerifiedElement.clientWidth);
  });
}
function setEndOfContenteditable(contentEditableElement) {
  let range;
  let selection;
  if (document.createRange) {
    range = document.createRange();
    range.selectNodeContents(contentEditableElement);
    range.collapse(false);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  } else if (document.selection) {
    range = document.body.createTextRange();
    range.moveToElementText(contentEditableElement);
    range.collapse(false);
    range.select();
  }
}
function handleOutsideClick(event) {
  const reportDropdownMenus = document.querySelectorAll(`${reportSelector} .dropdown-menu`);
  if (reportDropdownMenus.length) {
    reportDropdownMenus.forEach(menu => {
      const reportButton = menu.closest(reportSelector);
      if (!menu.classList.contains('hidden') && reportButton && !reportButton.contains(event.target)) {
        menu.classList.add('hidden');
      }
    });
  }
}
function toggleDropdownSortMenu(dropdownSortMenu) {
  if (!dropdownSortMenu) return;
  const dropdownBackground = document.querySelector('.js_dropdownBg');
  const dropdownClosebutton = dropdownSortMenu.querySelector('.dropdown_close');
  dropdownSortMenu.classList.toggle('hidden');
  if (window.isMob && dropdownBackground) {
    dropdownBackground.classList.toggle('hidden');
    dropdownBackground.addEventListener('click', () => toggleDropdownSortMenu(dropdownSortMenu));
    dropdownClosebutton.addEventListener('click', () => toggleDropdownSortMenu(dropdownSortMenu));
    toggleHtmlOverflow();
  }
}
function setupSorting() {
  const dropdownSortButton = document.querySelector('.js_sortDropdown');
  const dropdownSortMenu = document.querySelector('.js_sortMenu');
  if (!dropdownSortButton || !dropdownSortMenu) return;
  const dropdownSortItems = dropdownSortMenu.querySelectorAll('.js_sortItem');
  const urlParams = new URLSearchParams(window.location.search);
  const sortTypeFromUrl = urlParams.get('redoslijed');
  const updateUrlAndReload = sortType => {
    urlParams.set('redoslijed', sortType);
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.location.assign(newUrl);
  };
  dropdownSortButton.addEventListener('click', () => toggleDropdownSortMenu(dropdownSortMenu));
  dropdownSortItems.forEach(item => {
    item.classList.toggle('is-active', item.dataset.sortType === sortTypeFromUrl || !sortTypeFromUrl && item.dataset.sortType === 'relevantni');
    if (item.classList.contains('is-active')) {
      const spanElement = dropdownSortButton.querySelector('span');
      if (spanElement) spanElement.textContent = item.textContent;
    }
    item.addEventListener('click', () => {
      dropdownSortItems.forEach(otherItem => otherItem.classList.remove('is-active'));
      item.classList.add('is-active');
      const spanElement = dropdownSortButton.querySelector('span');
      if (spanElement) spanElement.textContent = item.textContent;
      updateUrlAndReload(item.dataset.sortType);
    });
  });
}
function setLoadingSpinner(sendButton) {
  sendButton.disabled = true;
  const loader = document.createElement('div');
  loader.classList.add('loader');
  sendButton.insertBefore(loader, sendButton.firstChild);
}
function stripHtml(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}
function setCommentsOwnReactions() {
  document.querySelectorAll(`${commentSelector} .like`).forEach(toggleReactionElements);
  document.querySelectorAll(`${commentSelector} .dislike`).forEach(toggleReactionElements);
}
function hideOtherReportMenus(commentId) {
  const unhiddenReportDropdownMenus = document.querySelectorAll(`${reportSelector} .dropdown-menu:not(.hidden)`);
  if (unhiddenReportDropdownMenus.length) {
    unhiddenReportDropdownMenus.forEach(menu => {
      if (!menu.classList.contains(`js_reportMenu-${commentId}`)) {
        menu.classList.add('hidden');
      }
    });
  }
}
function toggleReportButton(commentId) {
  const comment = document.querySelector(`#comment-${commentId}`);
  if (!comment) return;
  const background = comment.querySelector('.background');
  const reportMenu = comment.querySelector(`.js_reportMenu-${commentId}`);
  if (reportMenu) reportMenu.classList.toggle('hidden');
  if (background && window.isMob) {
    background.classList.toggle('hidden');
    toggleHtmlOverflow();
  }
  hideOtherReportMenus(commentId);
}
function getCaretPosition(contentEditableElement) {
  const selection = window.getSelection();
  if (selection.rangeCount === 0) return -1;
  if (contentEditableElement.childNodes.length == 1) {
    return selection.anchorOffset;
  }
  return contentEditableElement.innerHTML.indexOf(selection.anchorNode.textContent) + selection.anchorOffset;
}
function findAtPosition(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  let currentPosition = 0;
  let lastMention = null;
  function traverseNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent.replace(/\u00a0/g, ' ');
      const regex = /(?:^|\s|&nbsp;)@(\w*)/g;
      let match;
      while ((match = regex.exec(textContent)) !== null) {
        const mentionStartPosition = currentPosition + match.index;
        const mentionEndPosition = mentionStartPosition + match[0].length;
        if (mentionEndPosition == globalCursorPosition) {
          lastMention = {
            start: mentionStartPosition,
            end: mentionEndPosition,
            match
          };
        }
      }
      currentPosition += textContent.length;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName.toLowerCase() === 'mark') {
        currentPosition += node.outerHTML.length;
      } else {
        node.childNodes.forEach(traverseNodes);
      }
    }
  }
  traverseNodes(div);
  if (lastMention) {
    return {
      mentionStart: lastMention.start,
      mentionFullMatch: lastMention.match[0],
      mention: lastMention.match[1]
    };
  }
  return null;
}
function insertMention(mentionName, userId) {
  const mentionList = mentionContainer.querySelector(mentionListSelector);
  if (mentionList) {
    mentionList.innerHTML = '';
    mentionList.style.display = 'none';
  }
  mentionContainer.classList.add('hidden');
  const innerHtml = commentTextarea.innerHTML;
  const atPosition = findAtPosition(innerHtml);
  if (!atPosition) return;
  const {
    mentionStart,
    mentionFullMatch,
    _
  } = atPosition;
  const beforeMention = innerHtml.substring(0, mentionStart);
  const afterMention = innerHtml.substring(mentionStart + mentionFullMatch.length);
  const mentionHtml = `<mark data-id="${userId}" contenteditable="false">@${mentionName}</mark> `;
  commentTextarea.innerHTML = beforeMention + mentionHtml + afterMention;
  const sel = window.getSelection();
  const range = document.createRange();
  let setCaretElement = commentTextarea.childNodes[commentTextarea.childNodes.length - 1];

  // if mention is in the middle of the text, find the node where to put caret
  if (beforeMention) {
    let nodeHtml = '';
    let matchIndex = 0;
    for (let i = 0; i < commentTextarea.childNodes.length; i++) {
      nodeHtml = commentTextarea.childNodes[i]?.outerHTML || commentTextarea.childNodes[i].textContent;
      matchIndex = beforeMention.indexOf(nodeHtml);
      if (beforeMention.length > matchIndex + nodeHtml.length) {
        continue;
      } else {
        setCaretElement = commentTextarea.childNodes[i + 2];
        break;
      }
    }
  }

  // set caret at the end and focus
  range.selectNodeContents(commentTextarea);
  sel.removeAllRanges();
  sel.addRange(range);
  sel.collapse(setCaretElement, 1);
}
function createMentionListElement(mentions, mentionContainer) {
  const existingUl = mentionContainer.querySelector(`ul${mentionListSelector}`);
  if (existingUl) mentionContainer.removeChild(existingUl);
  const ulElement = document.createElement('ul');
  ulElement.className = 'mention-list';
  const template = document.getElementById('mention-template').content;
  mentions.forEach((mention, index) => {
    const clone = document.importNode(template, true);
    const liElement = clone.querySelector('li');
    if (!clone || !liElement) return;
    liElement.dataset.index = index;
    const avatarDiv = liElement.querySelector('.thread_comment__avatar');
    if (avatarDiv && mention.attributes) {
      if (mention.attributes?.avatar) {
        const imageElement = document.createElement('img');
        imageElement.src = mention.attributes.avatar;
        avatarDiv.append(imageElement);
      } else if (mention.attributes?.avatar_info) {
        avatarDiv.style.color = mention.attributes?.avatar_info?.font_color;
        avatarDiv.style.backgroundColor = mention.attributes?.avatar_info?.background_color;
        avatarDiv.textContent = mention.attributes?.avatar_info?.initials;
      }
    }
    const mentionNameSpan = liElement.querySelector('.mention-name');
    if (mentionNameSpan) mentionNameSpan.textContent = mention?.attributes?.name;
    liElement.addEventListener('click', () => insertMention(mention?.attributes?.name, mention?.attributes?.user_id));
    ulElement.appendChild(clone);
  });
  mentionContainer.appendChild(ulElement);
}
async function getMentions(threadId, text) {
  const mentionName = text.replace('@', '');
  const userToken = window.getUserToken();
  const apiUrl = threadId && threadId !== 'None' ? `${window.baseApiUrl}/mentions/${threadId}/profiles/${mentionName}` : `${window.baseApiUrl}/mentions/profiles/${mentionName}`;
  headers.Authorization = `Bearer ${userToken}`;
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers
    });
    const responseData = await response.json();
    return responseData.data;
  } catch (error) {
    console.error(error);
  }
}
function handleMentions(mentions) {
  const noMatchUl = mentionContainer?.querySelector(noMatchSelector);
  const mentionList = mentionContainer?.querySelector(mentionListSelector);
  if (mentions) {
    createMentionListElement(mentions, mentionContainer);
    if (noMatchUl) noMatchUl.style.display = 'none';
    if (mentionList) mentionList.style.display = 'block';
  } else {
    if (noMatchUl) noMatchUl.style.display = 'block';
    if (mentionList) mentionList.style.display = 'none';
  }
}
const debouncedGetMentions = window.debounce(async (threadId, searchTerm) => {
  const mentions = await getMentions(threadId, searchTerm);
  handleMentions(mentions);
}, 100);
function handleCharacterCount(event, characterCountElement) {
  const plainTextContent = commentTextarea.innerText;
  if (plainTextContent.length > 1500) {
    event.preventDefault();
  } else if (characterCountElement) {
    const currentCharacterCountAvailable = 1500 - plainTextContent.length;
    characterCountElement.textContent = `još ${currentCharacterCountAvailable}`;
  }
}
function hideMentionList(mentionContainer) {
  const mentionList = mentionContainer.querySelector(mentionListSelector);
  const noMatchUl = mentionContainer.querySelector(noMatchSelector);
  if (mentionList) {
    mentionList.style.display = 'none';
    mentionList.innerHTML = '';
  }
  if (noMatchUl) {
    noMatchUl.style.display = 'block';
  }
}
function handleMentionSuggestions(innerHtml) {
  if (!mentionContainer || !innerHtml) return;
  const atPosition = findAtPosition(innerHtml);
  if (!atPosition || globalCursorPosition < atPosition) {
    mentionContainer.classList.add('hidden');
    return;
  }
  const {
    mentionStart,
    mentionFullMatch,
    mention
  } = atPosition;
  const realMentionEnd = mentionStart + mentionFullMatch.length;
  const isCursorImmediatelyAfterMention = globalCursorPosition === realMentionEnd;
  if (mentionFullMatch.length >= 0 && isCursorImmediatelyAfterMention) {
    mentionContainer.classList.remove('hidden');
    if (mention.length >= 3) {
      const {
        threadId
      } = mentionContainer.dataset;
      if (threadId) debouncedGetMentions(threadId, mention);
    } else {
      hideMentionList(mentionContainer);
    }
  } else {
    mentionContainer.classList.add('hidden');
    hideMentionList(mentionContainer);
  }
}
function addBlockquoteToCommentsList(data) {
  const template = document.getElementById('comment_blockquote');
  if (!template) return null;
  const clone = template.content.cloneNode(true);
  if (!clone) return null;
  const blockquoteElement = clone.querySelector('.js_blockquote');
  if (!blockquoteElement) return null;
  const blockquoteContentElement = clone.querySelector('.js_blockquoteContent');
  if (blockquoteContentElement && data.content) blockquoteContentElement.innerText = data.content;
  const blockquoteAuthorElement = clone.querySelector('.js_blockquoteAuthor');
  if (blockquoteAuthorElement && data.author) blockquoteAuthorElement.innerText = `– ${data.author}`;
  if (commentsWrap && blockquoteElement) {
    commentsWrap.prepend(blockquoteElement);
  }
}
async function handleBlockquoteAndFetchData(newThreadCount = 0) {
  if (!siteWrap || siteWrap.classList.contains('comment-detail') || !commentsWrap) return;
  threadCount = newThreadCount || threadCount;
  const shouldShowBlockquote = threadCount === 0 || commentsWrap.childElementCount === 0;
  const blockquoteElement = commentsWrap.querySelector('.js_blockquote');
  if (shouldShowBlockquote) {
    const apiUrl = `${window.baseApiUrl}/comments/zero-comment`;
    try {
      const response = await fetch(apiUrl);
      if (response.ok) {
        const data = await response.json();
        if (data?.data?.attributes) {
          addBlockquoteToCommentsList(data.data.attributes);
        }
      }
    } catch (error) {
      console.error(error);
    }
  } else if (blockquoteElement) {
    blockquoteElement.remove();
  }
}
async function deleteComment(commentId) {
  const userToken = window.getUserToken();
  if (!userToken) return;
  const apiUrl = `${window.baseApiUrl}/comments/${commentId}`;
  const commentElement = document.querySelector(`#comment-${commentId}`);
  const dropdownFlagElement = commentElement.querySelector('.dropdown_flag');
  if (dropdownFlagElement) dropdownFlagElement.style.pointerEvents = 'none';
  const headers = {
    'Authorization': `Bearer ${userToken}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await fetch(apiUrl, {
      method: 'DELETE',
      headers
    });
    if (response.ok) {
      if (commentElement) commentElement.remove();
      if (threadCountElement) {
        const newThreadCount = threadCount - 1;
        threadCountElement.innerText = newThreadCount;
        handleBlockquoteAndFetchData(newThreadCount);
      }
      window.showSnackbar('Tvoj komentar je obrisan', 'success');
    } else {
      const errorData = await response.json();
      const errorMsg = errorData?.errors[0]?.detail;
      if (response.status === 403) {
        window.showSnackbar('Brisanje komentara nije dopušteno nakon 10 minuta', 'warning');
      } else if (errorMsg) {
        window.showSnackbar(errorMsg, 'warning');
      } else {
        window.showSnackbar('Došlo je do greške pri brisanju komentara', 'error');
      }
    }
  } catch (error) {
    window.showSnackbar('Došlo je do greške pri brisanju komentara', 'error');
  } finally {
    if (dropdownFlagElement) dropdownFlagElement.style.pointerEvents = 'auto';
  }
}
async function reportComment(commentId) {
  const userToken = window.getUserToken();
  if (!userToken) return;
  const apiUrl = `${window.baseApiUrl}/comments/${commentId}/report`;
  const reportCommentElement = document.querySelector(`.js_report-${commentId}`);
  if (!reportCommentElement) return;
  const dropdownFlagElement = reportCommentElement.querySelector('.dropdown_flag');
  if (dropdownFlagElement) dropdownFlagElement.pointerEvents = 'none';
  headers.Authorization = `Bearer ${userToken}`;
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers
    });
    if (response.ok) {
      reportCommentElement.remove();
      window.showSnackbar('Komentar je uspješno prijavljen', 'success');
    } else {
      window.showSnackbar('Tvoja prijava je već zaprimljena', 'error');
    }
  } catch (error) {
    window.showSnackbar('Došlo je do greške pri prijavi komentara', 'error');
  } finally {
    if (dropdownFlagElement) dropdownFlagElement.pointerEvents = 'auto';
  }
  toggleReportButton(commentId);
}
function processCommentAction(commentId, postedById) {
  if (!userProfileData || !commentId || !postedById) return;
  if (userProfileData.id === postedById) {
    deleteComment(commentId);
  } else {
    reportComment(commentId);
  }
}
function createCommentElement(commentData) {
  const template = document.getElementById('commentPost');
  if (!template) return;
  const clone = template.content.cloneNode(true);
  if (!clone) return;

  // Set the ID
  const commentElement = clone.querySelector('.thread_comment');
  if (commentElement) commentElement.id = `comment-${commentData.id}`;

  // Set the avatar or initials
  const avatarFigure = clone.querySelector('.thread_comment__avatar');
  const avatarImg = avatarFigure ? avatarFigure.querySelector('.thread_comment__avatar img') : null;
  const avatarInitials = clone.querySelector('.thread_comment__avatar--noimage');

  // Set verified image if user is verified
  const verifiedUserImg = clone.querySelector('.thread_comment__is_verified img');
  if (verifiedUserImg) {
    if (commentData.posted_by.data.is_verified) {
      verifiedUserImg.src = '/static/img/svg/verified.svg';
    } else {
      verifiedUserImg.remove();
    }
  }
  if (avatarInitials && avatarFigure) {
    if (commentData.posted_by.data.avatar && avatarImg) {
      avatarImg.src = `${commentData.posted_by.data.avatar}`;
      avatarImg.alt = `${commentData.posted_by.data.display_name}`;
      avatarImg.style.display = 'block';
      avatarInitials.style.display = 'none';
    } else {
      avatarInitials.textContent = commentData.posted_by.data.avatar_info.initials;
      avatarInitials.style.color = commentData.posted_by.data.avatar_info.font_color;
      avatarInitials.style.backgroundColor = commentData.posted_by.data.avatar_info.background_color;
      avatarFigure.style.display = 'none';
      avatarInitials.style.display = 'flex';
    }
  }

  // Set the username and time
  const usernameElement = clone.querySelector('.thread_comment__username');
  if (usernameElement) usernameElement.textContent = commentData.posted_by.data.display_name;

  // Format the created_date to 'hh:mm'
  const createdDate = new Date(commentData.created_date);
  const hours = createdDate.getHours().toString().padStart(2, '0');
  const minutes = createdDate.getMinutes().toString().padStart(2, '0');
  const commentTimeElement = clone.querySelector('.thread_comment__time');
  if (commentTimeElement) commentTimeElement.textContent = `${hours}:${minutes}`;

  // Set the comment content
  const commentContent = clone.querySelector('.thread_comment__content span');
  if (commentContent) commentContent.innerHTML = commentData.content;

  // Set the like and dislike buttons
  const likeElement = clone.querySelector('.thread_comment__meta_reaction.like');
  if (likeElement) {
    likeElement.classList.add(`js_like-${commentData.id}`);
    likeElement.addEventListener('click', () => addReaction(commentData.id, 'like'));
  }
  const dislikeElement = clone.querySelector('.thread_comment__meta_reaction.dislike');
  if (dislikeElement) {
    dislikeElement.classList.add(`js_dislike-${commentData.id}`);
    dislikeElement.addEventListener('click', () => addReaction(commentData.id, 'dislike'));
  }
  const replyElement = clone.querySelector('.thread_comment__reply');
  if (replyElement) {
    if (siteWrap && siteWrap.classList.contains('comment-detail')) {
      replyElement.remove();
    } else {
      replyElement.setAttribute('href', `${window.location.origin}${window.location.pathname}/${commentData.id}/komentar`);
    }
  }

  // Set the report dropdown class
  const deleteButton = clone.querySelector('.btn__dropdown--delete');
  if (deleteButton) deleteButton.addEventListener('click', () => toggleReportButton(commentData.id));
  const dropdownMenu = clone.querySelector('.dropdown-menu');
  if (dropdownMenu) dropdownMenu.classList.add(`js_reportMenu-${commentData.id}`);
  const reportBackground = clone.querySelector('.background');
  const reportClose = dropdownMenu ? dropdownMenu.querySelector('.dropdown_close') : null;
  if (window.isMob && (reportBackground || reportClose)) {
    reportBackground.addEventListener('click', () => toggleReportButton(commentData.id));
    reportClose.addEventListener('click', () => toggleReportButton(commentData.id));
  }
  const dropdownFlagElement = dropdownMenu ? dropdownMenu.querySelector('.dropdown_flag') : null;
  if (dropdownFlagElement) dropdownFlagElement.addEventListener('click', () => deleteComment(commentData.id));
  return commentElement;
}
function addNewCommentToCommentsList(commentData, commentsParent) {
  if (!commentsWrap) return;
  const newComment = createCommentElement(commentData);
  if (commentsParent) {
    commentsWrap.append(newComment);
    // eslint-disable-next-line no-use-before-define
    loadLastPage(true);
  } else {
    commentsWrap.prepend(newComment);
  }
  newComment.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
}
async function postComment(event, itemId) {
  const userToken = window.getUserToken();
  if (!userToken) {
    window.openModalWelcome('comments');
    return;
  }
  const sendButton = event.srcElement;
  const isPieceCommentPage = siteWrap.classList.contains('site_wrap--piece_thread');
  const {
    commentsParent
  } = sendButton.dataset;
  const commentContent = `<span>${commentTextarea.innerHTML.trim()}</span>`;
  let apiUrl = `${window.baseApiUrl}/comments/${itemId}`;
  if (!commentsParent) apiUrl = isPieceCommentPage ? `${window.baseApiUrl}/pieces/${itemId}/comments` : `${window.baseApiUrl}/articles/${itemId}/comments`;
  headers.Authorization = `Bearer ${userToken}`;
  setLoadingSpinner(sendButton);
  const postData = {
    data: {
      type: 'comment',
      attributes: {
        content: commentContent
      }
    }
  };
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers
    });
    if (response.ok) {
      const data = await response.json();
      const commentData = window.kitsuCore.deserialise(data).data;
      commentTextarea.innerHTML = '';
      if (threadCountElement) {
        const newThreadCount = threadCount + 1;
        threadCountElement.innerText = newThreadCount;
        handleBlockquoteAndFetchData(newThreadCount);
      }
      addNewCommentToCommentsList(commentData, commentsParent);
      window.showSnackbar('Komentar je uspješno objavljen', 'success');
    } else {
      const errorData = await response.json();
      const errorMsg = errorData ? errorData?.errors[0].detail : null;
      if (errorMsg) window.showSnackbar(errorMsg, 'warning');
    }
  } catch (error) {
    window.showSnackbar('Došlo je do greške pri postavljanju komentara', 'error');
  } finally {
    const loader = sendButton.querySelector('.loader');
    if (loader && loader.parentNode === sendButton) sendButton.removeChild(loader);
    sendButton.disabled = false;
  }
}
function toggleCommentsLoader(shown) {
  const commentsLoadingWrap = document.querySelector('#commentsLoadingWrap');
  if (commentsLoadingWrap) commentsLoadingWrap.hidden = !shown;
}
function goToDetailCommentPage(returnUrl, commentId) {
  const userToken = window.getUserToken();
  if (userToken) {
    document.location.pathname = `${returnUrl}/komentari/${commentId}/komentar`;
  } else {
    window.openModalWelcome('comments');
  }
}
function unhideDeleteOwnCommentButtons(comment, reportButton) {
  const tenMinutesMilliseconds = 600000;
  const now = new Date().getTime();
  const createdDate = comment.getAttribute('data-created-date');
  if (createdDate) {
    const commentTime = new Date(createdDate).getTime();
    const timeDiff = now - commentTime;
    reportButton.classList.toggle('hidden', timeDiff >= tenMinutesMilliseconds);
  }
}
function createUserAvatar(userProfileData, avatarElement, isReplyAvatar = false) {
  const avatarSize = isReplyAvatar ? 24 : 40;
  if (userProfileData.avatar) {
    const figure = document.createElement('figure');
    figure.classList.add('thread_comment__avatar');
    if (isReplyAvatar) figure.classList.add('thread_comment__avatar--badge');
    const img = document.createElement('img');
    img.src = userProfileData.avatar;
    img.alt = userProfileData.display_name;
    img.width = avatarSize;
    img.height = avatarSize;
    figure.appendChild(img);
    avatarElement.appendChild(figure);
  } else if (userProfileData.avatar_info) {
    const div = document.createElement('div');
    div.classList.add('thread_post__avatar', 'thread_post__avatar--noimage');
    div.style.backgroundColor = userProfileData.avatar_info.background_color;
    div.style.color = userProfileData.avatar_info.font_color;
    div.textContent = userProfileData.avatar_info.initials;
    div.width = avatarSize;
    div.height = avatarSize;
    avatarElement.appendChild(div);
  }
}
function updateComments(unprocessedComments) {
  unprocessedComments.forEach(comment => {
    comment.classList.add('processed');
    const {
      postedById
    } = comment.dataset;
    const reportButton = comment.querySelector(reportSelector);
    const isPostedByUser = postedById && postedById === userProfileData.id;
    if (reportButton) {
      const reportToggleButton = reportButton.querySelector('.js_toggleButton');
      const reportTitle = reportButton.querySelector('.js_reportTitle');
      const reportLink = reportButton.querySelector('.js_reportLink');
      if (reportToggleButton) {
        const reportToggleButtonSpanElement = reportToggleButton.querySelector('span');
        if (reportToggleButtonSpanElement && isPostedByUser) reportToggleButtonSpanElement.classList.remove('hidden');
        reportToggleButton.classList.add(isPostedByUser ? 'btn__dropdown--delete' : 'btn__dropdown--report');
      }
      if (reportTitle) reportTitle.innerText = isPostedByUser ? 'Brisanje komentara' : 'Nepoćudan komentar?';
      if (reportLink) reportLink.innerText = isPostedByUser ? 'Obriši vlastiti komentar' : 'Prijavi komentar';
      if (isPostedByUser) {
        comment.classList.add('posted-by-user');
        unhideDeleteOwnCommentButtons(comment, reportButton);
      } else {
        reportButton.classList.remove('hidden');
      }
    }
    const commentWithMyReply = comment.querySelector('.js_commentWithMyReply');
    if (commentWithMyReply && userProfileData) createUserAvatar(userProfileData, commentWithMyReply, true);
  });
}
function showFirstOrLastPageButtons() {
  const loadFirstBtnWrap = document.querySelector('.load-first-btn-wrap');
  const loadLastBtnWrap = document.querySelector('.load-last-btn-wrap');
  if (commentsWrap.classList.contains('first-page-loaded')) {
    loadFirstBtnWrap?.classList.toggle('hidden', shouldToggleButtonVisibility(commentsWrap, 'top'));
  }
  if (commentsWrap.classList.contains('total-pages-loaded')) {
    loadLastBtnWrap?.classList.toggle('hidden', shouldToggleButtonVisibility(commentsWrap, 'bottom', 50));
  }
}

/**
 * Called from unicorn component upon successful page load.
 */
// eslint-disable-next-line no-unused-vars
function loadDone() {
  toggleCommentsLoader(false);
  checkAndSetTruncatedClass();
  if (userProfileData) {
    if (userProfileData.id) {
      const markElementsWithUserId = document.querySelectorAll(`.js_commentsContent mark[data-id='${userProfileData.id}']`);
      markElementsWithUserId?.forEach(markElement => markElement.classList.add('own-mention'));
    }
    unprocessedComments = [...document.querySelectorAll(`${commentSelector}:not(.processed)`)].slice(-10);
    setCommentsOwnReactions();
    if (unprocessedComments) updateComments(unprocessedComments);
  }
  if (window.initProcessingSubsequentlyAddedDfpSlots) {
    window.initProcessingSubsequentlyAddedDfpSlots('.list_comments');
  }
}
function loadFirstPage(refresh = false) {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  if (refresh) {
    window.Unicorn.call('comments', 'load_first_page');
  } else {
    document.querySelector('.load-first-btn-wrap')?.classList.add('hidden');
    document.querySelector('.load-last-btn-wrap')?.classList.remove('hidden');
  }
}
function loadLastPage(loadPage = false) {
  if (loadPage) {
    window.Unicorn.call('comments', 'load_last_page');
  } else {
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
    document.querySelector('.load-first-btn-wrap')?.classList.remove('hidden');
    document.querySelector('.load-last-btn-wrap')?.classList.add('hidden');
  }
}
async function setDetailCommentsOwnReactions(commentId) {
  const apiUrl = `${window.baseApiUrl}/comments/${commentId}`;
  headers.Authorization = `Bearer ${window.getUserToken()}`;
  const response = await fetch(apiUrl, {
    method: 'GET',
    headers
  });
  if (response.ok) {
    try {
      const responseData = await response.json();
      const isLikedByMe = responseData.data.attributes.liked_by_logged_in_user;
      const isDislikedByMe = responseData.data.attributes.disliked_by_logged_in_user;
      const commentElement = document.getElementById(`comment-${commentId}`);
      if (!isLikedByMe && !isDislikedByMe) return;
      if (isLikedByMe) {
        const likeElement = commentElement?.querySelector(`.js_like-${commentId}`);
        likeElement?.classList?.add('active');
        if (likeElement) toggleReactionElements(likeElement);
      } else {
        const disLikeElement = commentElement?.querySelector(`.js_dislike-${commentId}`);
        disLikeElement?.classList?.add('active');
        if (disLikeElement) toggleReactionElements(disLikeElement);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const threadFooter = document.querySelector('.js_threadFooterRight');
  if (window.isMob && threadFooter) threadFooter.classList.add('hidden');
  if (userProfileData?.display_name) {
    const isCommentDetail = window.location.pathname.endsWith('komentar');

    // set own reaction on comment detail view
    if (isCommentDetail) {
      const parentCommentId = window.location.pathname.split('/').slice(-2, -1).pop();
      setDetailCommentsOwnReactions(parentCommentId);
    }
    const markElementsWithUserId = document.querySelectorAll(`.js_commentsContent mark[data-id='${userProfileData.id}']`);
    if (markElementsWithUserId) {
      markElementsWithUserId.forEach(markElement => markElement.classList.add('own-mention'));
    }
    if (avatarElement) createUserAvatar(userProfileData, avatarElement);
    if (commentTextarea) {
      let prevInnerHtml = commentTextarea.innerHTML;
      commentTextarea.addEventListener('input', event => {
        const currentTextLength = commentTextarea.innerText.length;
        const characterCountElement = document.querySelector('.js_characterCount');
        if (currentTextLength > 1500) {
          commentTextarea.innerHTML = prevInnerHtml;
          setEndOfContenteditable(commentTextarea);
        } else {
          prevInnerHtml = commentTextarea.innerHTML;
          if (currentTextLength === 0 && !mentionContainer.classList.contains('hidden')) {
            mentionContainer.classList.add('hidden');
          }
        }
        const innerHtml = commentTextarea.innerHTML.replace(/&nbsp;/g, ' ').replace(/\u00a0/g, ' ');
        const hasText = innerHtml.length > 0;
        globalCursorPosition = getCaretPosition(commentTextarea);
        if (sendButton) sendButton.toggleAttribute('disabled', !hasText);
        handleMentionSuggestions(innerHtml);
        handleCharacterCount(event, characterCountElement);
      });
      commentTextarea.addEventListener('paste', event => {
        event.preventDefault();
        const pasteContent = (event.clipboardData || window.clipboardData).getData('text/plain');
        const currentContent = commentTextarea.textContent;
        const totalContent = currentContent + pasteContent;
        if (totalContent.length > 1500) {
          const allowedContent = pasteContent.substring(0, 1500 - currentContent.length);
          document.execCommand('insertText', false, allowedContent);
        } else {
          document.execCommand('insertText', false, pasteContent);
        }
      });
      document.addEventListener('click', event => {
        const isCommentTextareaEventTargeted = commentTextarea.contains(event.target);
        const isMentionEventTargeted = mentionContainer ? mentionContainer.contains(event.target) : null;
        if (!isCommentTextareaEventTargeted && !isMentionEventTargeted) {
          mentionContainer.classList.add('hidden');
        }
        if (window.isMob && (isCommentTextareaEventTargeted || isMentionEventTargeted) && threadFooter && threadFooter.classList.contains('hidden')) {
          threadFooter.classList.remove('hidden');
        }
      });
    }
    const reportButtons = document.querySelectorAll(reportSelector);
    if (reportButtons) {
      reportButtons.forEach(reportButton => {
        reportButton.addEventListener('click', event => {
          const commentId = reportButton.getAttribute('data-comment-id');
          if (commentId) toggleReportButton(commentId);
          event.stopPropagation();
        });
      });
      document.addEventListener('click', handleOutsideClick);
    }
    if (sendButton) {
      if (sendButton.classList.contains('hidden')) sendButton.classList.remove('hidden');
      if (window.isMob && commentTextarea.innerHTML.length > 0) sendButton.disabled = true;
    }
    unprocessedComments = document.querySelectorAll(`${commentSelector}:not(.processed)`);
    setCommentsOwnReactions();
    if (unprocessedComments) updateComments(unprocessedComments);
  } else if (commentTextarea) {
    commentTextarea.addEventListener('click', () => userProfileData ? window.openModalChangeDisplayName() : window.openModalWelcome('comments'));
  }
  const sortDropDownElement = document.querySelector('.js_sortDropdown');
  if (sortDropDownElement) setupSorting();
  checkAndSetTruncatedClass();
  handleBlockquoteAndFetchData();
  if (commentsWrap && !commentsWrap.classList.contains('total-pages-loaded')) {
    showFirstOrLastPageButtons();
    window.addEventListener('scroll', window.debounce(() => showFirstOrLastPageButtons(), 200), {
      passive: true
    });
  }

  /**
  * Set up a debounced scroll event listener to load more comments when the trigger is in the viewport.
  *
  * This code selects the elements for comments loading trigger and wrapper, and adds a scroll event listener
  * to the window. The event listener is debounced to execute at most once every 200 milliseconds. When the
  * scroll event is triggered, the function checks if the comments loading wrapper is hidden and if the
  * comments loading trigger element is in the viewport. If both conditions are met, it toggles the comments
  * loader to visible and calls the 'load_next_page' method for the 'comments' component using Unicorn.
  */
  window.addEventListener('scroll', window.debounce(() => {
    const commentsLoadingTrigger = document.querySelector('#commentsLoadingTrigger');
    const commentsLoadingWrap = document.querySelector('#commentsLoadingWrap');
    if (commentsLoadingWrap && commentsLoadingWrap.hidden && window.isInViewport(commentsLoadingTrigger)) {
      toggleCommentsLoader(true);
      window.Unicorn.call('comments', 'load_next_page');
    }
  }, 200), {
    passive: true
  });
});
window.addEventListener('pageshow', e => {
  // If served from bfcache and userProfileData is in memory, re-check if data is 
  // still there. If not, refresh (needed for proper logout flow)
  if (e.persisted && userProfileData && !window.getProfileData()) {
    window.location.reload();
  }
});